import React, { useState, useEffect } from "react";
import AddSupplier from "./AddSupplier";
import Modal from "../../components/Modal";
import { getSuppliers } from "../../apis/Supplier";
import { getSupplierById } from "../../apis/Supplier";
import { Pagination, PaginationProps } from "antd";
import CommonPagination from "../../components/CommanPagination";

const SupplierList = () => {
  const [isSupplierModalOpen, setSupplierModalVisibility] = useState(false);
  const [suppliers, setSuppliers] = useState<any[]>([]);
  const [editableId, setEditableId] = useState(null);
  const [meta, setMeta] = useState<any>();
  const [editableSupplier, setEditableSupplier] = useState<any>(null);

  const fetchSuppliers = (params: any = { page: 1, per_page: 10 }) => {
  getSuppliers(params)
    .then((res: any) => {
      const dataArray = Array.isArray(res.data) ? res.data : [];
      setSuppliers(dataArray);
      setMeta(res.meta);   
    })
    .catch((err) => console.error(err));
};

  const onPaginationChange = (page: number, pageSize?: number) => {
  fetchSuppliers({ page, per_page: pageSize || 10 }); 
};

  useEffect(() => {
    fetchSuppliers({ page: 1, per_page: 10 });
  }, []);

  const handleCloseModal = () => {
    setEditableId(null);
    setSupplierModalVisibility(false);
    fetchSuppliers();
  };

  const handleEditSupplier = (supplier: any) => {
  const supplierId = supplier.id;
  getSupplierById(supplierId)
    .then((res: any) => {
      setEditableSupplier(res.data); 
      setEditableId(supplierId);
      setSupplierModalVisibility(true);
    })
    .catch((err) => console.error(err));
};

  return (
    <div className="px-4 sm:px-6 lg:px-8">

      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Supplier List
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            List of all suppliers.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => setSupplierModalVisibility(true)}
            className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover"
          >
            Add Supplier
          </button>
          <button
            type="button"
            className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
          >
            Export
          </button>
        </div>
      </div>

      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Name
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Contact Person
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Phone
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Email
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody className="bg-white divide-y divide-gray-200">
                  {suppliers.map((s) => (
                    <tr key={s.id}>
                      <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{s.name}</td>
                      <td className="py-4 px-3 text-sm text-gray-700">{s.contactPerson}</td>
                      <td className="py-4 px-3 text-sm text-gray-700">{s.phone}</td>
                      <td className="py-4 px-3 text-sm text-gray-700">{s.email}</td>
                      <td className="py-4 px-3 text-sm text-gray-700">
                        <button
                          onClick={() => handleEditSupplier(s)}
                          className="block px-3 py-2 text-white bg-primary rounded hover:bg-hover"
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>

        {isSupplierModalOpen && (
          <Modal
            title={editableId ? "Update Supplier" : "Add Supplier"}
            onClose={handleCloseModal}
            modalContent={
              <AddSupplier
                editableId={editableId}
                supplierData={editableSupplier} 
                closeModal={handleCloseModal}
              />
            }
          />
        )}
      </div>
    </div>
  );
};

export default SupplierList;
